import React from 'react';
import EnhancedSelectSearch from '../../search-page-resources/jsx/EnhancedSelectSearch';

const Query = ({
    SORTING_OPTIONS,
    searchInputHasFocus,
    searchInputText,
    onSearchInputBlur,
    onSearchInputChange,
    onSearchInputFocus,
    SEARCH_INPUT_PLACEHOLDERS,
    isRequestingSearchSuggestions,
    onClearSearchButtonClick,
    searchSuggestions,
    onSuggestionButtonClick,
    searchSummaryJson,
    generateFacetTags,
}) => {
    return (
        <div className="search-page-resources__query-section">
            <EnhancedSelectSearch
                componentId="sort"
                selectOptions={SORTING_OPTIONS}
            />

            <div className="search-page-resources__search-container">
                {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                <label className="sr-only" htmlFor="resources-search-input">
                    Search the website for a resource
                </label>
                <input
                    autoComplete="off"
                    className={`search-page-resources__search-input ${
                        searchInputHasFocus || searchInputText !== ''
                            ? 'is-expanded'
                            : ''
                    }`}
                    id="resources-search-input"
                    onBlur={onSearchInputBlur}
                    onChange={onSearchInputChange}
                    onFocus={onSearchInputFocus}
                    placeholder={
                        searchInputHasFocus
                            ? SEARCH_INPUT_PLACEHOLDERS.onFocus
                            : SEARCH_INPUT_PLACEHOLDERS.onBlur
                    }
                    spellCheck="false"
                    type="text"
                    value={searchInputText}
                />

                {isRequestingSearchSuggestions ? (
                    <div className="search-page-resources__input-loading-wrapper">
                        <span className="sr-only">
                            Looking for search suggestions
                        </span>
                        <div
                            title="Looking for search suggestions"
                            className="search-page-resources__input-loading-animation"
                        />
                    </div>
                ) : null}

                <button
                    className="search-page-resources__search-submit"
                    type="submit"
                >
                    <span className="sr-only">Submit search</span>
                    <svg className="svg-icon">
                        <use href="#rse-search-page-glass" />
                    </svg>
                </button>

                {searchInputText !== '' ? (
                    <button
                        className="search-page-resources__search-clear"
                        onClick={onClearSearchButtonClick}
                        type="button"
                    >
                        <span className="sr-only">Clear search</span>
                        <svg className="svg-icon">
                            <use href="#rse-close" />
                        </svg>
                    </button>
                ) : null}

                {searchSuggestions ? (
                    <ol className="search-page-resources__search-suggestions-list">
                        {searchSuggestions.map((suggestion) => {
                            return (
                                <li
                                    className="search-page-resources__search-suggestions-list-item"
                                    key={suggestion.id}
                                >
                                    <button
                                        className="search-page-resources__search-suggestions-option"
                                        data-suggestion={suggestion.value}
                                        onClick={onSuggestionButtonClick}
                                        type="button"
                                    >
                                        {suggestion.label}
                                    </button>
                                </li>
                            );
                        })}
                    </ol>
                ) : null}
            </div>

            <p className="search-page-resources__results-summary">
                {searchSummaryJson.totalMatching} resources found
            </p>

            <div className="search-page-resources__tags-mobile">
                {generateFacetTags()}
            </div>
        </div>
    );
};

export default Query;
